import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';

import { UpgradeImage } from './UpgradeImage';

export const UpgradeSuccess = () => (
  <div className="vai-flex vai-flex-col vai-items-center vai-gap-12">
    <p className="vai-font-merriweather vai-font-bold vai-text-3xl vai-text-navy-500 vai-z-10">
      <Trans>Detect AI is upgraded!</Trans>
    </p>

    <div className="vai-relative vai-flex vai-items-center vai-mb-8">
      <div className="vai-bg-white vai-rounded-full vai-p-[6px] vai-z-20 vai-absolute vai-left-1/2 vai-transform vai--translate-x-1/2 -vai-bottom-8">
        <FontAwesomeIcon
          size="7x"
          icon={faCheckCircle}
          className="vai-text-leaf-400"
        />
      </div>
      <UpgradeImage
        className="vai-h-52 vai-w-72 -vai-rotate-6 -vai-mr-10"
        imagePath="assets/images/external/clinical-view-image.png"
      />
      <UpgradeImage
        className="vai-h-72 vai-w-96 vai-z-10"
        imagePath="assets/images/external/patient-view-image.png"
      />
      <UpgradeImage
        className="vai-h-52 vai-w-72 vai-rotate-6 -vai-ml-10"
        imagePath="assets/images/external/visit-sidebar.png"
      />
    </div>
    <p className="vai-font-inter vai-font-semibold vai-text-navy-500 vai-text-center">
      <Trans>
        Changes will take effect on the next patient you open, and your monthly
        billing status will be updated within 72 hours.
      </Trans>
    </p>
  </div>
);
